<template>
  <table-index
    :config="tableConfig"
    :table-classes="'table-index'"
  />
</template>

<script>
import TableIndex from '@/global/components/table/TableIndex.vue'
import mainTableConfig from '../config/main-table/main-table-config'
import { isEmpty } from 'lodash'

export default {
  name: 'AggregatorSolutionsMain',

  mixins: [
    mainTableConfig
  ],

  components: {
    TableIndex
  },

  data () {
    return {
      mainTableLeafletMapComponent: () => import('../../common/components/mainTableLeafletMap.vue')
    }
  },

  beforeCreate () {
    if (!isEmpty(this.$route.query)) {
      this.$router.push({
        name: 'Aggregator_requests_details',
        query: this.$route.query
      })
    }
  }
}
</script>

<style scoped>
::v-deep {
  .table-index {
    .table-row {
      flex-wrap: nowrap;
      width: 100%;
    }
    .table-side-col {
      display: flex;
      padding: 12px 0 12px 0;
    }
  }
}
</style>
